export const DEFAULT_SIZE_REQUEST = 100;

export const DISCOUNT_FRESH_DAYS_COUNT = 30;
export const DISCOUNT_RELEVANCE_DAYS_COUNT = 5;
export const DEFAULT_DATE = new Date().toISOString().split('T')[0];
export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const COUNT_CHAR_FOR_START_SEARCH = 3;

export const COUNT_MAX_CARD_FOR_SEARCH_RESULT = 7;
export const COUNT_PIXEL_ON_TOP_INDENT_IN_SEARCH_LIST = 20;
export const COUNT_PIXEL_ON_ONE_CATEGORY = 118;
export const COUNT_PIXEL_DESCRIPTION_SEARCH_IN_MOBILE = 44;
export const COUNT_PIXEL_DESCRIPTION_SEARCH_IN_DESKTOP = 98;

export const TMP_INITIAL_DISCOUNT_LOAD_COUNT = 24;
export const TMP_LOAD_MORE_BATCH_SIZE = 12;
export const COUNT_MIN_CARD_FOR_UP_BTN = 6;

export const COUNT_ITEMS_ON_PAGE: { [key: string]: number } = {
  mobile: 6,
  tablet: 12,
  notebook: 12,
  desktop: 18,
};

export const FOUND_DECLINATION_ARR_RU = ['Найден', 'Найдено', 'Найдено'];
export const RESULT_DECLINATION_ARR_RU = [
  'результат',
  'результата',
  'результатов',
];
export const RESULT_DECLINATION_ARR_ENG = ['result', 'results'];

export const CITY_DECLINATION_ARR_RU = ['локация', 'локации', 'локаций'];
export const CITY_DECLINATION_ARR_ENG = ['location', 'locations', 'locations'];

export const COUNT_SIMILAR_CARDS = 3;

export const COUNT_CARDS_BY_CATEGORY_MAIN_PAGE = 12;

export const MIN_CARDS_TO_SHOW_CAROUSEL = 3;

export const CARD_WIDTH_DESKTOP_PX = 396;

export const CARD_GAP_PX = 20;

export const DEFAULT_COUNT_CATEGORIES_IN_MAIN_PAGE = 6;

export const DEFAULT_PAGE_NUMBER = 0;

export const DEFAULT_COUNT_LATEST_DISCOUNTS_IN_MAIN_PAGE = 20;

export const DEFAULT_STEPS_AMOUNT_IN_STEPPER_DISCOUNT_REQUEST = 2;

export const TOKEN_CACHE_LIFE_TIME_MS = 10000;

export const PHONE_ADDRESS_DB_SEPARATOR = ' / ';

export enum LayoutValue {
  GRID = 'grid',
  TABLE = 'table',
}
